module.exports = __webpack_public_path__ + "static/hyperv_30.125a436b.jpg";